import classNames from 'classnames';
import React from 'react';
import type { BaseLayerViewType } from '@/version-types';
import { useElementClickEvents, useFramework } from '../hooks/framework';

/** 用于自定义操作层的点击事件 */
export const OperateClickEvents: React.FC<{
    layerId: string;
    dataOperateType?: BaseLayerViewType;
    className?: string;
    styles?: React.CSSProperties;
    children?: React.ReactNode;
    onClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => boolean;
    onDoubleClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => boolean;
}> = ({ layerId, styles = {}, className = '', children = null, dataOperateType, onClick, onDoubleClick }) => {
    const framework = useFramework();
    const events = useElementClickEvents(layerId, {
        onClick: (e) => {
            if (onClick?.(e)) return;
            framework.service.frame.__emitLayerClickEvent(layerId, {
                x: e.pageX || 0,
                y: e.pageY || 0,
            });
        },
        onDoubleClick: (e) => {
            if (onDoubleClick?.(e)) return;
            framework.service.frame.__emitLayerDoubleClickEvent(layerId, {
                x: e.pageX || 0,
                y: e.pageY || 0,
            });
        },
    });

    return (
        <div
            {...(dataOperateType ? { 'data-operate-type': dataOperateType } : {})}
            className={classNames(className)}
            style={{
                pointerEvents: 'all',
                width: '100%',
                height: '100%',
                position: 'absolute',
                left: 0,
                top: 0,
                ...styles,
            }}
            {...events}
        >
            {children}
        </div>
    );
};
